const ACTIVE_CLASS = 'AuditStages__single--active';
const stages = document.querySelectorAll('.AuditStages__single');
const animationTime = 10000;
let currentStep = 0;

const clearAnimation = () => {
    currentStep = 0;
    stages?.forEach((stage) => {
        stage.classList.remove(ACTIVE_CLASS);
    });
};

const animateLine = () => {
    document.querySelector('.AuditStages__inner-line').style.width = `${currentStep * 25}%`;
};

const initAnimation = () => {
    if (!stages.length) return;
    setInterval(() => {
        currentStep += 1;
        if (currentStep === stages.length) {
            clearAnimation();
        }

        stages[currentStep].classList.add(ACTIVE_CLASS);
        animateLine();
    }, animationTime / stages.length);
};

initAnimation();


var box = $("#AuditStages"), x;
$("#audit__next").click(function() {
  // if ($(this).hasClass("arrow-right")) {
    x = ((box.width() / 2)) + box.scrollLeft();
    box.animate({
      scrollLeft: x,
    })

})
$("#audit__prev").click(function() {
  // if ($(this).hasClass("arrow-right")) {
    x = ((box.width() / 2)) - box.scrollLeft();
    box.animate({
      scrollLeft: -x,
    })

})